export default "__VITE_PUBLIC_ASSET__90c951e1__"